import React, { useContext } from "react";
import { ClientProps, WellProps } from "../../interfaces/interfaces";
import DataContext from "../../context/DataContext";
import { Autocomplete, Grid } from "@mui/material";
import DesignerContext from "../../context/DesignerContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { additional_info_options } from "../../utils/data";
import { StyledTextField } from "../../utils/formStyles";

export function PullingForm() {
  const { clientOptions, wellOptions, fetchDataWells } =
    useContext(DataContext);
  const { pullingInfo, onEditPullingInfo } = useContext(DesignerContext);

  const handleChange = (name: string, value: any) => {
    onEditPullingInfo((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <StyledTextField
          id="custom-design-name"
          label="Custom Design Name"
          variant="outlined"
          value={pullingInfo.customName || ""}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            handleChange("customName", event.target.value)
          }
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Autocomplete<string>
          value={pullingInfo.pullingName || ""}
          onChange={(_: any, newValue: string | null) =>
            handleChange("pullingName", newValue)
          }
          options={additional_info_options}
          getOptionLabel={(option: string) => option}
          renderOption={(props: any, option: string) => (
            <li {...props} key={option}>
              {option}
            </li>
          )}
          disablePortal
          renderInput={(params: any) => (
            <StyledTextField {...params} label="Additional Info" />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Autocomplete<ClientProps>
          value={pullingInfo.well?.client || null}
          onChange={(_: any, newValue: ClientProps | null) => {
            if (newValue) {
              onEditPullingInfo((prev) => ({
                ...prev,
                well: { ...prev.well, client: newValue },
              }));
              fetchDataWells(newValue.id);
            }
          }}
          options={clientOptions}
          getOptionLabel={(option: ClientProps) => option.name}
          renderOption={(props: any, option: ClientProps) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          disablePortal
          renderInput={(params: any) => (
            <StyledTextField {...params} label="Client name" />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Autocomplete<WellProps>
          value={pullingInfo.well || null}
          onChange={(_: any, newValue: WellProps | null) => {
            if (newValue) {
              onEditPullingInfo((prev) => ({
                ...prev,
                well: { client: prev.well?.client, ...newValue },
              }));
            }
          }}
          options={wellOptions}
          getOptionLabel={(option: WellProps) => option.name}
          renderOption={(props: any, option: WellProps) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
          disablePortal
          renderInput={(params: any) => (
            <StyledTextField {...params} label="Well name" />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePicker
          label="Installation Date"
          value={
            pullingInfo.installationDate
              ? dayjs(pullingInfo.installationDate)
              : dayjs()
          }
          onChange={(newValue) =>
            handleChange("installationDate", newValue ? newValue.toDate() : null)
          }
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              borderRadius: "12px",
              border: "1px solid rgba(90, 100, 119, 0.3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(90, 100, 119, 0.15)",
              },
            },
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePicker
          label="Pulling Date"
          value={
            pullingInfo.pullingDate ? dayjs(pullingInfo.pullingDate) : dayjs()
          }
          onChange={(newValue) =>
            handleChange("pullingDate", newValue ? newValue.toDate() : null)
          }
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              borderRadius: "12px",
              border: "1px solid rgba(90, 100, 119, 0.3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 1)",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(90, 100, 119, 0.15)",
              },
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
